import { AxiosRequestConfig } from 'axios';

import base from '@/services/base';

import { API2, API3,API1 } from '@/config/apiHost';
import {isAPP, isDiyiSdk, isTalkJoy} from "@/appApi";
import { appver } from "@/common/script/unit";


// 刷新用户状态
export function changeUserVipInfo(utk: string) {
    const config: AxiosRequestConfig = {
        url: `${ API1 }/dashboard/get_user_vip_info`,
        method: 'get',
        params: {
            save_cache: 1,
            utk
        }
    };
    return base(config);
}

export function memberProduct(from: string, book_id = '') {
    const params: any = {};
    if (from) {
        params.from = from;
    }
    if (book_id) {
        params.book_id = book_id;
    }
    const config: AxiosRequestConfig = {
        url: `${ API1 }/dashboard/my_vip_product_info`,
        method: 'get',
        params
    };
    return base(config);
}

export function getVipText(product_type = 'sale', activity_id = '0'): Promise<any> {

    const params: any = {
        product_type,
    };
    if (activity_id || activity_id !== '0') {
        params.activity_id = activity_id;
    }
    const config: AxiosRequestConfig = {
        url: `${ API2 }/dy/member_product_info`,
        method: 'get',
        params
    };
    return base(config);
}

export function isVip(): any {
    const config: AxiosRequestConfig = {
        url: `${ API1 }/dashboard/user_vip_info`,
        method: 'get'
    };
    return base(config);
}

export function userInfo(): any {
    let url = `${ API2 }/dy/only_user_info`;

    if (
      ( isAPP() && appver() >= 110300 )
      || !isAPP()
      || isDiyiSdk()
      || isTalkJoy()
    ) {
        url = `${ API1 }/authuser/only_user_info`;
    }
    
    // if (isDiyiSdk()) {
    //     url = `${ API1 }/nbschool/only_user_info`
    // }

    const config: AxiosRequestConfig = {
        url,
        method: 'get'
    };
    return base(config);
}

export function userActivityOrder(order_id: string, activity_id: string):Promise<any> {
    const config: AxiosRequestConfig = {
        url: `${ API2 }/dy/user_activity_order`,
        method: 'get',
        params: {
            order_id,
            activity_id
        }
    };
    return base(config);
}

// 3000+ 课文有声书免费畅听
export function getGalleries(grade: string | undefined): any {

    const url = `${ API2 }/dy/listen_book_list?from_vip=1`;
    const params: any = {};
    if (grade) {
        // url = `${ API2 }/dy/listen_book_list/?grade=${grade}`;
        params.grade = grade;
    }
    const config: AxiosRequestConfig = {
        url,
        params,
        method: 'get'
    };
    return base(config);
}

// 2本点读课本免费学
export function getBookList(grade: string | undefined): any {
    const url = `${ API2 }/dy/vip_show_book_list`;
    const params: any = {};
    if (grade) {
        // url = `${ API2 }/dy/vip_show_book_list/?grade=${grade}`;
        params.grade = grade;
    }
    const config: AxiosRequestConfig = {
        url,
        params,
        method: 'get'
    };
    return base(config);
}

// 魔法课本
export function getMagicBookList(grade: string | undefined): any {
    const url = `${ API1 }/dashboard/books/all_books`;
    const params: any = {
        book_type:'magic_book',
        grade: '1a'
    };
    if (grade) {
        params.grade = grade;
    }
    const config: AxiosRequestConfig = {
        url,
        params,
        method: 'get'
    };
    return base(config);
}

// 教辅
export function getTeachList(grade: string | undefined, subKind = '同步教辅'): any {
    const url = `${ API1 }/dashboard/books/show_teach`;
    const params: any = {
        sub_kind: subKind,
        grade: '1a'
    };
    if (grade) {
        params.grade = grade;
    }
    const config: AxiosRequestConfig = {
        url,
        params,
        method: 'get'
    };
    return base(config);
}

// 特权书籍
export function getPreroLists(grade: string | undefined): any {
    const url = `${ API2 }/dy/vip_books?from_vip=1`;
    const params: any = {};
    if (grade) {
        // url = `${ API2 }/dy/vip_books/?grade=${grade}`;
        params.grade = grade;
    }
    const config: AxiosRequestConfig = {
        url,
        params,
        method: 'get'
    };
    return base(config);
}

// 获取开通会员地址
export function getAlipayUrl(pid: number, tag_id: number, activityId = '') :Promise<any> {
    const url = `${ API3 }/pay/member/alipay/order-sign`;
    const params: any = {
        pid,
        tag_id
    };
    if (activityId) {
        params.activity_id = activityId;
    }
    const config: AxiosRequestConfig = {
        url,
        params,
        method: 'get'
    };
    return base(config);
}

// 获取年级书本权益
export function getMainBooksProGuideInfo(grade = '3a') :Promise<any> {
    const url = `${ API2 }/dy/main_books_pro_guide_info`;
    const params: any = {
        grade
    };
    const config: AxiosRequestConfig = {
        url,
        params,
        method: 'get'
    };
    return base(config);
}

// 老会员升级
export function vipUpgrade() :Promise<any> {
    const url = `${ API1 }/dashboard/vip_upgrade`;
    const config: AxiosRequestConfig = {
        url,
        method: 'get'
    };
    return base(config);
}

// 获取会员产品信息（年度/月度）
export function getVipProduct(grade = '3a') :Promise<any> {
    const url = `${ API1 }/dashboard/user_pay_vip_product`;
    const config: AxiosRequestConfig = {
        url,
        method: 'get',
        params: {
            grade
        }
    };
    return base(config);
}

export function getActivityCamp() :Promise<any> {
    const url = `${ API1 }/dashboard/camp_activity/subject_camp?subject=推荐`;
    const config: AxiosRequestConfig = {
        url,
        method: 'get'
    };
    return base(config);
}

export function extraProductInfo() :Promise<any> {
    const url = `${ API1 }/pay/extra_product_info`;
    const config: AxiosRequestConfig = {
        url,
        method: 'get'
    };
    return base(config);
}

export function getDiscountList(product_id: string, extra_product_ids: number) :Promise<any> {
    const url = `${ API1 }/pay/discount_list`;
    const config: AxiosRequestConfig = {
        url,
        method: 'get',
        params: {
            product_id,
            extra_product_ids
        }
    };
    return base(config);
}

export function getLearningData() {
    const url = `${ API1 }/dashboard/learning_data`;
    const config: AxiosRequestConfig = {
        url,
        method: 'get',
    };
    return base(config);
}

export function isOpenActivity(type: string) {
    const url = `${ API1 }/order/activity_is_open`;
    const config: AxiosRequestConfig = {
        url,
        method: 'get',
        params: {
            activity_type: type
        }
    };
    return base(config);
}